// Código limpio sin logs complejos para evitar errores de sintaxis
let completeLookSwipercont = $(".complete-look-cart-wrapper").html();

function AddProductToCart(t) {
    $("body").addClass("no-scroll"), $(".PageOverlay").addClass(" is-visible"), $("#sidebar-cart").attr("tabindex", "-1"), $("#sidebar-cart").attr("aria-hidden", "false"), jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: t,
        dataType: "json",
        success: function(t) {
            document.dispatchEvent(new CustomEvent("pixel:add_to_cart", {
                detail: {
                    line_item: t
                }
            }));
            $(".Drawer__Main").prepend('<div class="skeleton"><div class="cartItem_skeleton"><div class="item_image_skeleton_cover"><div class="item_image_skeleton"></div></div><div class="item_info_skeleton"><div class="info_title"></div><div class="info_subTitle"></div><div class="info_price"></div><div class="info_cover"><div class="info_qty"></div><div class="info_remove"></div></div></div></div></div>'), $(".social_shop_popup_wrapper").removeClass("show"), $(".backLayer").fadeOut(), $(".social_shop_popup ").removeClass("hide"), $(".social_popup_more_info").removeClass("show"), localStorage.removeItem("open-shop"), getCartJSON()
        },
        error: function(xhr, status, error) {
            console.error("Error adding to cart:", error);
        }
    })
}

function getCartJSON() {
    $.getJSON("/cart.js").then((function(t) {
        $(".Header__CartDot").text(t.item_count), t.item_count > 0 && $(".Header__CartDot").addClass("is-visible"), $(".Drawer__Footer").remove();
        var e = "",
            a = [],
            i = {},
            r = $(".cart-items-from-js");
        if ($.each(t.items, (function(t, e) {
                if (null != e.image) var r = e.image.replace(/(\.[^.]*)$/, "_large$1").replace("http:", "");
                else r = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
                for (var n = 0; n < e.options_with_values.length; n++) var o = e.options_with_values[n].value;
                if (null != e.properties || "" != e.properties) e.properties;
                else;
                i = {
                    id: e.id,
                    key: e.key,
                    line: t + 1,
                    url: e.url,
                    img: r,
                    name: e.product_title,
                    optionswithvalues: o,
                    variation: e.variant_title,
                    properties: e.properties,
                    itemAdd: e.quantity + 1,
                    itemMinus: e.quantity - 1,
                    itemQty: e.quantity,
                    price: e.price,
                    originalPrice: e.original_price,
                    finalPrice: e.final_price,
                    discountedPrice: e.discounted_price,
                    totalDiscount: e.total_discount,
                    discounts: e.discounts,
                    lineDiscounts: e.line_level_discount_allocations,
                    product_has_only_default_variant: e.product_has_only_default_variant,
                    grams: e.grams,
                    vendor: e.vendor,
                    linePrice: e.line_price,
                    originalLinePrice: e.original_line_price,
                    discountsApplied: e.total_discount > 0 || e.discounts.length > 0 || e.line_level_discount_allocations.length > 0
                }, a.push(i)
            })), $(".skeleton").hide("fast", (function() {
                $(".skeleton").remove()
            })), document.querySelector(".free-shipping-alert")) {
            const t = document.querySelector(".free-shipping-alert").getAttribute("data-limit");
            setTimeout((() => {
                const e = document.querySelector("#sidecart__submit_btn").getAttribute("data-total"),
                    a = 100 * e / t,
                    i = document.querySelector(".free-shipping-alert").getAttribute("data-currency"),
                    r = t - e;
                document.querySelector(".free-shipping-alert .progress-bar-line__active").style.width = a + "%", document.querySelector(".left_money_alert").textContent = r/100 + i, a > 100 ? (document.querySelector(".free-shipping-alert").style.display = "block", document.querySelector(".not-free-text").style.display = "none", document.querySelector(".free-text-d").style.display = "block") : (document.querySelector(".free-shipping-alert").style.display = "block", document.querySelector(".not-free-text").style.display = "block", document.querySelector(".free-text-d").style.display = "none")
            }), 600)
        }
        
        let n = document.querySelector("#sidebar-cart").getAttribute("data-delete");
        
        // Detectar idioma basado en la URL y configurar traducciones
        function getTranslations() {
            const currentPath = window.location.pathname;
            
            // Detectar idioma por la URL
            if (currentPath.startsWith('/es/') || currentPath === '/es') {
                return {
                    model: "MODELO",
                    size: "TALLA"
                };
            } else if (currentPath.startsWith('/it/') || currentPath === '/it') {
                return {
                    model: "MODELLO",
                    size: "TAGLIA"
                };
            } else {
                // Por defecto inglés
                return {
                    model: "MODEL",
                    size: "SIZE"
                };
            }
        }
        
        const translations = getTranslations();
        let modelLabel = translations.model;
        let sizeLabel = translations.size;
        
        for (var o = 0; o < t.items.length; o++) {
            // LÓGICA DE DESCUENTOS MEJORADA - OBTENER COMPARE_AT_PRICE
            var hasDiscount = false;
            var originalPriceToUse = a[o].price;
            var finalPriceToUse = a[o].price;
            var discountPercentage = 0;
            
            // Función para obtener compare_at_price del producto
            var getCompareAtPrice = function(variantId, callback) {
                // Usar la URL del producto para obtener los datos completos
                var productHandle = a[o].url.split('/').pop().split('?')[0];
                $.getJSON('/products/' + productHandle + '.js')
                    .done(function(productData) {
                        var compareAtPrice = null;
                        // Buscar la variante específica
                        for (var v = 0; v < productData.variants.length; v++) {
                            if (productData.variants[v].id == variantId) {
                                compareAtPrice = productData.variants[v].compare_at_price;
                                break;
                            }
                        }
                        callback(compareAtPrice);
                    })
                    .fail(function() {
                        callback(null);
                    });
            };
            
            // 1. Verificar si hay descuentos totales aplicados
            if (a[o].totalDiscount && a[o].totalDiscount > 0) {
                hasDiscount = true;
                originalPriceToUse = a[o].originalPrice;
                finalPriceToUse = a[o].finalPrice;
                discountPercentage = Math.round((a[o].totalDiscount * 100) / a[o].originalPrice);
            }
            // 2. Verificar si hay descuentos de línea
            else if (a[o].lineDiscounts && a[o].lineDiscounts.length > 0) {
                hasDiscount = true;
                originalPriceToUse = a[o].originalLinePrice / a[o].itemQty;
                finalPriceToUse = a[o].linePrice / a[o].itemQty;
                discountPercentage = Math.round(((originalPriceToUse - finalPriceToUse) * 100) / originalPriceToUse);
            }
            // 3. Verificar si original_price es diferente de final_price
            else if (a[o].originalPrice && a[o].finalPrice && a[o].originalPrice > a[o].finalPrice) {
                hasDiscount = true;
                originalPriceToUse = a[o].originalPrice;
                finalPriceToUse = a[o].finalPrice;
                discountPercentage = Math.round(((originalPriceToUse - finalPriceToUse) * 100) / originalPriceToUse);
            }
            // 4. Si no hay descuentos detectados, intentar obtener compare_at_price
            else {
                // Crear closure para mantener el índice
                (function(index) {
                    getCompareAtPrice(a[index].id, function(compareAtPrice) {
                        if (compareAtPrice && compareAtPrice > a[index].finalPrice) {
                            // Regenerar este item específico con descuento
                            updateCartItemWithDiscount(index, compareAtPrice, a[index].finalPrice);
                        }
                    });
                })(o);
            }
            
            parseInt(o), parseInt(o);
            var s = parseInt(finalPriceToUse),
                l = "<div class='CartItemWrapper'>";
            l += "<div class='CartItem'>", l += "<div class='CartItem__ImageWrapper AspectRatio'>", l += "<a href='" + a[o].url + "'>", l += "<div class='AspectRatio' style='--aspect-ratio: 1.0'>", l += "<img class='CartItem__Image' src='" + a[o].img + "' alt='" + a[o].img.alt + "'>", l += "</div>", l += "</a>", l += "</div>", l += "<div class='CartItem__Info'>", l += "<h2 class='CartItem__Title Heading'>";
            var c = a[o].name.split("|");
            l += "<a href='" + a[o].url + "'>" + c[0] + "</a>", l += "</h2>";
            
            // Usar las traducciones obtenidas
            l += '<p class="CartItem__Title"><span style="font-weight: normal;">' + modelLabel + ':</span> ' + c[1] + "</p>";
            
            l += "<div class='CartItem__Meta Heading Text--subdued'>";
            
            // Usar las traducciones obtenidas para TALLA
            if (null != a[o].variation) {
                l += "<p class='CartItem__Variant'><span style='font-family: Filson Pro Book !important; font-weight: normal;'>" + sizeLabel + ":</span> " + a[o].variation + "</p>";
            }
            
            l += "<div class='CartItem__PriceList'>";
            
            // MOSTRAR PRECIOS CON DESCUENTO
            if (hasDiscount && discountPercentage > 0) {
                l += "<div style='display: flex; align-items: center; gap: 8px; flex-wrap: wrap;'>";
                l += "<span class='CartItem__OriginalPrice' style='color: #999; text-decoration: line-through; font-size: 0.9em;'>" + theme.formatMoney(originalPriceToUse, theme.moneyFormat) + "</span>";
                l += "<span class='CartItem__Price' style='font-weight: bold; color: #000;'>" + theme.formatMoney(finalPriceToUse, theme.moneyFormat) + "</span>";
                l += "<span class='CartItem__DiscountBadge' style='background-color: #000; color: #fff; padding: 2px 6px; border-radius: 3px; font-size: 0.8em; font-weight: bold;'>-" + discountPercentage + "%</span>";
                l += "</div>";
            } else {
                l += "<span class='CartItem__Price Price'>" + theme.formatMoney(s, theme.moneyFormat) + "</span>";
            }
            
            l += "</div>", l += "</div>", l += "<div class='CartItem__Actions Heading Text--subdued' style='text-align: center'>", l += "<div class='CartItem__QuantitySelector'>", l += "<div class='QuantitySelector'>", l += "<a class='QuantitySelector__Button Link Link--primary' title='Set quantity to 0' href='/cart/change?quantity=" + (parseInt(a[o].itemQty) - 1) + "&amp;line=" + (o + 1) + "' data-quantity='" + (parseInt(a[o].itemQty) - 1) + "' data-line='" + (o + 1) + "' data-action='update-item-quantity'>", l += "<svg class='Icon Icon--minus' role='presentation' viewBox='0 0 16 2'><path d='M1,1 L15,1' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg>", l += "</a>", l += "<input type='text' name='updates[]' id='updates_" + a[o].key + "' class='QuantitySelector__CurrentQuantity' pattern='[0-9]*' data-line='" + (o + 1) + "' value='" + a[o].itemQty + "'>", l += "<a class='QuantitySelector__Button Link Link--primary' title='Set quantity to 2' href='/cart/change?quantity=" + (parseInt(a[o].itemQty) + 1) + "&amp;line=" + (o + 1) + "' data-quantity='" + (parseInt(a[o].itemQty) + 1) + "' data-line='" + (o + 1) + "' data-action='update-item-quantity'>", l += "<svg class='Icon Icon--plus' role='presentation' viewBox='0 0 16 16'><g stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'><path d='M8,1 L8,15'></path><path d='M1,8 L15,8'></path></g></svg>", l += "</a>", l += "</div>", l += "</div>", l += "<a href='/cart/change?quantity=0&amp;line=" + (o+1) + "' class='CartItem__Remove Link Link--underline Link--underlineShort' data-quantity='0' data-line='" + (o+1) + "' data-action='remove-item'>" + n + "</a>", l += "</div>", l += "</div>", l += "</div>", e += l += "</div>"
        }
        
        // Función para actualizar un item específico con descuento encontrado
        function updateCartItemWithDiscount(itemIndex, originalPrice, finalPrice) {
            var discountPercentage = Math.round(((originalPrice - finalPrice) * 100) / originalPrice);
            var itemSelector = '.CartItemWrapper:eq(' + itemIndex + ') .CartItem__PriceList';
            
            var discountHtml = "<div style='display: flex; align-items: center; gap: 8px; flex-wrap: wrap;'>";
            discountHtml += "<span class='CartItem__OriginalPrice' style='color: #999; text-decoration: line-through; font-size: 0.9em;'>" + theme.formatMoney(originalPrice, theme.moneyFormat) + "</span>";
            discountHtml += "<span class='CartItem__Price' style='font-weight: bold; color: #000;'>" + theme.formatMoney(finalPrice, theme.moneyFormat) + "</span>";
            discountHtml += "<span class='CartItem__DiscountBadge' style='background-color: #000; color: #fff; padding: 2px 6px; border-radius: 3px; font-size: 0.8em; font-weight: bold;'>-" + discountPercentage + "%</span>";
            discountHtml += "</div>";
            
            $(itemSelector).html(discountHtml);
        }
        
        r.html('<div class="Cart__ItemList">' + e + "</div>");
        var d = t.total_price;
        var u = "<div class='Drawer__Footer' data-drawer-animated-bottom>";
        if(completeLookSwipercont){
            u += completeLookSwipercont;
        }
        
        setTimeout(() => {
            const carousel = document.querySelector('.Drawer__Footer .complete-look-carousel');
            if (carousel && typeof Flickity !== 'undefined') {
              new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                groupCells: 2,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: true,
                freeScroll: true
              });
            }
        }, 100)
        
        u += "<button type='submit' name='checkout' id='sidecart__submit_btn' data-total=" + d + " class='Cart__Checkout Button Button--primary Button--full'>", u += "<span> " + document.querySelector("#sidebar-cart").getAttribute("data-checkout") + " </span>", u += "<span class='Button__SeparatorDot'></span><span>" + theme.formatMoney(d, theme.moneyFormat) + "</span>", u += "</button>", u += '<div id="pago-expres-divider">', u += '<hr class="cart-pay-line left-line">', u += '<span class="cart-pay-text">Express payment</span>', u += '<hr class="cart-pay-line right-line">', u += '</div>', u += '<div class="Cart__OffscreenNoteContainer" aria-hidden="true">', u += '<span class="Cart__NoteButton">Añadir comentario al pedido</span>', u += '<div class="Form__Item">', u += '<textarea class="Cart__Note Form__Textarea" name="note" id="cart-note" rows="3" placeholder="How can we help you?" data-scrollable=""></textarea>', u += "</div>", u += '<button type="button" class="Button Button--primary Button--full" data-action="toggle-cart-note">Save</button>', u += "</div>", u += "</div>", $(".Cart.Drawer__Content .Drawer__Main").after(u);

    })).catch(function(error) {
        console.error("Error in getCartJSON:", error);
    });
}

$(document).on("click", ".CartItem__Remove", (function() {
    setTimeout((() => {
        $.getJSON("/cart.js").then((function(t) {
            $(".Header__CartDot").text(t.item_count)
            setTimeout(() => {
                const carousel = document.querySelector('.Drawer__Footer .complete-look-carousel');
            if (carousel && typeof Flickity !== 'undefined') {
              new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                groupCells: 2,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: true,
                freeScroll: true
              });
            }
            })
        }))
    }), 1e3)
})), $(document).on("click", ".call-to-action-btn", (function() {
    AddProductToCart({
        id: $("#adding-variant").val(),
        quantity: "1"
    })
    
})), $(document).on("submit", '[data-action="product-form"]', (function(t) {
    t.preventDefault();
    const e = new FormData(this);
    AddProductToCart(Object.fromEntries(e))
})), $(document).on("click", ".quick-add-to-cart-btn", (function(t) {
    AddProductToCart({
        id: $(this).find("input[type=radio]").data("variant_id"),
        quantity: "1"
    })
}));